module.exports = __webpack_public_path__ + "static/healthtrackrx-5b5520db0ed98f2c365c40c91baa1ad2.png";